import React from 'react';
import { withFullHydrate } from '@ecommerce/nest-ssr/common';
import StaticPageLayoutDesktop from 'layouts/static-page-layout/static-page-layout.desktop';
import RegulationsBase from 'modules/static-pages/regulations-page/pages/regulations-page.base';

const RegulationsDesktop: React.FC = () => (
    <StaticPageLayoutDesktop>
        <RegulationsBase />
    </StaticPageLayoutDesktop>
);

export default withFullHydrate(RegulationsDesktop, { root: '#root' }, 'modules/static-pages/regulations-page/pages/regulations-page.desktop');
